import { render, staticRenderFns } from "./KeyBind.vue?vue&type=template&id=126fd22a&scoped=true&"
import script from "./KeyBind.vue?vue&type=script&lang=js&"
export * from "./KeyBind.vue?vue&type=script&lang=js&"
import style0 from "./KeyBind.vue?vue&type=style&index=0&id=126fd22a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126fd22a",
  null
  
)

export default component.exports